import React from 'react';
import { IndexLink } from 'react-router';
import PropTypes from 'prop-types';

const ScrollableMenu = ({ menus }) => (
  <ul className="nav bg-white scroll-menu scroll-menu--shadow">
    {
      Object.keys(menus)
        .map((key, index) => (
          <li key={`scroll-menu-item-${index}`} className="nav-item">
            <IndexLink to={menus[key]}
                       className="nav-link scroll-menu__item"
                       activeClassName="scroll-menu__item--active">{key}</IndexLink>
          </li>
        ))
    }
  </ul>
);

ScrollableMenu.propTypes = {
  menus: PropTypes.object.isRequired,
};

export default ScrollableMenu;



// WEBPACK FOOTER //
// ./src/Common/ScrollableMenu.js